module.exports = __webpack_public_path__ + "img/success.100f025a.svg";